import React, { FC } from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton,
  Grid,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { doc, updateDoc } from 'firebase/firestore'
import { firebase_firestore } from '../../common/firebaseConfig'

import PhoneNumberInput from '../form/PhoneNumberInput'

interface PhoneValidationDialogProps {
  open: boolean
  onClose: () => void
  alert: any
  onAlertKeyChange: (key: string, value: any) => void
}

const PhoneValidationDialog: FC<PhoneValidationDialogProps> = ({
  open,
  onClose,
  alert,
  onAlertKeyChange,
}) => {
  const handlePhoneNumberChange = async (value: string) => {
    if (value) {
      onAlertKeyChange('user.phoneNumber', value)

      const updatedAlertTypes = Array.from(new Set([...alert.alertTypes, 'sms']))
      onAlertKeyChange('alertTypes', updatedAlertTypes)

      if (alert.id) {
        try {
          const alertRef = doc(firebase_firestore, 'tradingPlans', alert.id)
          await updateDoc(alertRef, {
            'user.phoneNumber': value,
            alertTypes: updatedAlertTypes,
          })
        } catch (error) {
          console.error('Error updating alert in Firestore:', error)
        }
      }

      onClose()
    }
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant="h6">Phone Number Verification</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize={'small'} />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" paragraph>
            To receive SMS alerts, please provide and verify your phone number.
          </Typography>

          <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
            <Grid item xs={12} sm={3}>
              <Typography variant="body2">Phone number:</Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <PhoneNumberInput
                phoneNumber={alert?.user?.phoneNumber || ''}
                onPhoneNumberChange={handlePhoneNumberChange}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default PhoneValidationDialog
